import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';
import Label from '../Label';

const Textarea = ({
  handleChange,
  labelText,
  placeholderText,
  width,
  height,
  value,
  name,
  disabled,
}) => (
  <>
    <Label text={labelText} hasMargin htmlFor={name} />
    <S.Textarea
      name={name}
      id={name}
      value={value}
      fieldWidth={width}
      fieldHeight={height}
      onChange={handleChange}
      placeholder={placeholderText}
      disabled={disabled}
    />
  </>
);

export default Textarea;

Textarea.defaultProps = {
  handleChange: () => {},
  width: 100,
  height: 90,
  value: '',
  disabled: false,
};

Textarea.propTypes = {
  handleChange: PropTypes.func,
  labelText: PropTypes.string.isRequired,
  placeholderText: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};
